<template>
    <v-snackbar v-model="showNotification" absolute top @input="dequeue">
        <span>
            {{ notification }}
            <v-btn variant="text" flat color="white" @click="hide"> OK </v-btn>
        </span>
    </v-snackbar>
</template>

<script lang="ts" setup>
import { ref } from 'vue';

const notifications: string[] = [];
const notification = ref(null);

const showNotification = ref(false);

function dequeue() {
    notification.value = notifications.shift();
    showNotification.value = !!notification.value;
}

function show(value: string) {
    let message = value;

    switch (value) {
        case 'tripCompleted':
            message = 'Turen ble registrert.';
            break;
        case 'tripCancelled':
            message = 'Turen ble kansellert.';
            break;
        case 'messageSent':
            message = 'Melding ble sendt.';
            break;
        case 'createTripFailed':
            message = 'Kunne ikke opprette tur. Prøv igjen senere.';
    }

    notifications.push(message);
    dequeue();
}

function hide() {
    showNotification.value = false;
    dequeue();
}

defineExpose({ show });
</script>

<style lang="scss" scoped>
span {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
}

.v-btn {
    background-color: rgb(var(--v-theme-surface-variant)) !important;
    color: rgb(var(--v-theme-on-surface-variant)) !important;
}
</style>
